import { forwardRef } from 'react';

import { RiCloseLine as CloseIcon } from '@remixicon/react';
import classNames from 'classnames';

import { ButtonIcon } from '@backstage/ui';

import styles from './CloseButtonBui.module.css';
import { useDialogContext } from './context';

export type CloseButtonBuiProps = {
  className?: string;
  isDisabled?: boolean;
  onPress?: () => void;
};

export const CloseButtonBui = forwardRef<
  HTMLButtonElement,
  CloseButtonBuiProps
>((props, ref) => {
  const { className, onPress, ...rest } = props;
  const { onClose } = useDialogContext();

  const handlePress = () => {
    onPress?.();
    onClose();
  };

  return (
    <ButtonIcon
      ref={ref}
      aria-label="close"
      variant="tertiary"
      size="small"
      icon={<CloseIcon />}
      onPress={handlePress}
      className={classNames(styles.root, className)}
      data-track-id="button.close"
      data-track-action="dismiss"
      {...rest}
    />
  );
});

CloseButtonBui.displayName = 'DialogCompositeBui.CloseButton';

export default CloseButtonBui;
